import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const CommonServer = {
    Mine: {
        /**
         * 更新当前登录管理员信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/index/upinfo`,
                params
            );
        },
        /**
         * 刷新邀请码
         */
        refresh: (params?: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/index/refreshInviteCode`,
                { params }
            );
        },
    },
    Home: {
        /**
         * 统计
        */
        statistic: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/statistic/index`,
                { params }
            );
        },
        /**
        * 提醒
       */
        remind: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/statistic/remind`,
                { params }
            );
        }
    },
    Level: {
        /**
         * 等级列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/grade/list`,
                { params }
            );
        },
        /**
         * 等级添加
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/grade/add`, params);
        },
        /**
         * 等级更新
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/grade/update`,
                params
            );
        },
        /**
         * 修改状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/grade/update`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
    },
}